<div *ngIf="isshowfilter && data">
    <search-list [title]="searchTitle" (change)="criteriaChange($event)"></search-list>
</div>
<br />
<div *ngIf="data" class="add-btn-postion">
    <div>
        <ng-container *ngFor="let hdrbtn of hdrbtns">
            <button *ngIf="!hdrbtn.ishide" type="button" class="btn btn-primary float-right" (click)="click(hdrbtn,null)">{{hdrbtn.title}}</button>
        </ng-container>
       <button *ngIf="isExporttoCSV && (data!=null && data.length>0)" type="button" class="btn btn-primary" (click)="exporttoCSV()">Export to Excel</button>
    </div>
</div>

<div>
    <table class="table table-hover table-sortable" border="0" *ngIf='data ; else loadingScreen;'>
        <thead>
            <tr>
                <th *ngFor="let column of columns" [class]="selectedClass(column.variable)"
                    (click)="changeSorting(column.variable)">
                    {{column.display}}
                </th>
                <ng-container *ngFor="let btn of gridbtns">
                    <td *ngIf="!btn.ishide"></td>
                </ng-container>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let row of pdata | orderby : convertSorting()">
                <td *ngFor="let column of columns">
                    {{row[column.variable] | format : column.filter}}
                </td>
                <ng-container *ngFor="let btn of gridbtns">
                    <td *ngIf="!btn.ishide">
                        <button type="button" class="btn btn-primary" (click)="click(btn,row)">{{btn.title}}</button>
                    </td>
                </ng-container>
            </tr>
        </tbody>
    </table>
    <div *ngIf='data && data.length==0' class="alert alert-info" role="alert">No record found!</div>
    <ng-template #loadingScreen>
        <div class="alert alert-info" role="alert">
            <!--<md-progress-spinner mode="indeterminate" style="width:50px; height:50px"></md-progress-spinner>-->
          loading...
        </div>
    </ng-template>
</div>
